import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import { PropsWithChildren, Ref, useCallback, useEffect, useRef, useState } from 'react';

export interface IHBInfiniteScrollProps extends PropsWithChildren {
  callback: () => void | Promise<void>;
}

export function HBInfiniteScroll({ children, callback }: IHBInfiniteScrollProps): JSX.Element {
  const elRef: Ref<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const intersectionEntry = useIntersectionObserver(elRef, { threshold: 0.1 });
  const [isLoading, setIsLoading] = useState(false);
  const onIntersect = useCallback(async () => {
    try {
      if (!isLoading) {
        setIsLoading(true);
        await callback();
      }
    } finally {
      setIsLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (intersectionEntry?.isIntersecting) {
      onIntersect();
    }
  }, [intersectionEntry?.isIntersecting, onIntersect]);

  // * children is for optional loading animation and what not
  return <div ref={elRef}>{children}</div>;
}
